import { useRef } from "react";
import PropTypes from "prop-types";
import ReactPlayer from 'react-player';
import useIsVisible from "../hooks/useIsVisible";

const Landing3rd = ({ locale }) => {
    const playerRef = useRef(null);
    const isVisible = useIsVisible(playerRef);

    return (
        <div className='landing-element-container' id="landing-page-3rd">
            <div className='landing-element-content pt-4'>
                <div className='row'>
                    <div className='col-md-6 d-flex flex-column justify-content-center'>
                        <h1>{locale.title}</h1>
                        <p>{locale.subtitle}</p>
                    </div>
                    <div className='col-md-6' ref={playerRef}>
                        <ReactPlayer
                            playing={isVisible}
                            src={locale.videoUrl}
                            muted
                            loop
                            style={{ width: '100%', height: 'auto', aspectRatio: '4/4' }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

Landing3rd.propTypes = {
    locale: PropTypes.object.isRequired
}

export default Landing3rd;
